import { getField, updateField } from 'vuex-map-fields';

const getters = {
    getField,

    shipToStateId: state => {
        if (state.shipping_same_as_billing) {
            return state.billing.state_id
        }
        return state.shipping.state_id
    }
};

const state = {
    special_instructions: [],
    states: [],
    shippingCarriers: [],
    shippingMethods: [],
    order_details: {},
    order_summary: [],
    show_special_instructions: {},
    shipping: {
        company_name: null,
        address_1: null,
        address_2: null,
        address_3: null,
        address_4: null,
        state_id: null,
        city: null,
        postal_code: null,
        contact_name: '',
        contact_phone: '',
        use_carrier_account: 0,
        use_innotech_address: 0,
    },
    billing: {
        address_1: null,
        address_2: null,
        address_3: null,
        address_4: null,
        state_id: null,
        city: null,
        postal_code: null,
    },
    shipping_same_as_billing: 0,
    po_number: '',
    global_due_date: "",
    due_dates: {},
    specialShippingInstructions: {},
    payment_method: "credit_card",
    payment_token: {},
    card_token_to_use: '',
    new_coupon: undefined,
    created_by_admin: 0,
    customer_id: null,
    stepper: 1,
    paymentMethodDisplay: ''
};

const mutations = {
    updateField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};